import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

  constructor(
    private auth: AuthService,
    private router: Router,
    private snack: MatSnackBar
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isLogged: boolean = this.auth.autenticado();
    const session = localStorage.getItem('session')
      ? JSON.parse(localStorage.getItem('session')!)
      : null;

    let request = req;

    if (isLogged && session?.token) {
      request = req.clone({
        setHeaders: {
          Authorization: `Bearer ${session.token}`
        }
      });
    }

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          const reason = err.error?.reason;

          switch (reason) {
            case 'expired':
              this.snack.open('⚠️ Tu sesión expiró. Volvé a iniciar sesión.', 'Cerrar', {
                duration: 4000,
                panelClass: ['snackbar-error']
              });
              this.auth.logOut();
              this.router.navigate(['/login']);
              break;

            case 'invalid':
              this.snack.open('❌ Sesión inválida. Iniciá sesión nuevamente.', 'Cerrar', {
                duration: 4000,
                panelClass: ['snackbar-error']
              });
              this.auth.logOut();
              this.router.navigate(['/login']);
              break;

            case 'no_permission':
              this.snack.open('🚫 No tenés permisos para esta acción.', 'Cerrar', {
                duration: 4000,
                panelClass: ['snackbar-warning']
              });
              break;

            default:
              this.snack.open('❌ Error de autenticación.', 'Cerrar', {
                duration: 4000,
                panelClass: ['snackbar-error']
              });
              break;
          }
        }

        return throwError(() => err);
      })
    );
  }
}
